<template>
  <div class="StudyGuide">
    <ul>
      <li>
        <img src="../assets/StudyGuide/01.jpg" alt="" />
      </li>
      <li>
        <img src="../assets/StudyGuide/02.jpg" alt="" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style>
img {
  width: 100%;
  height: 100%;
  vertical-align: top;
}
</style>